import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Cell } from 'recharts'
import { ChartContainer } from '../../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../../common/chart/chartContainer/Bar'
import { Legend } from '../../../../../../../common/chart/legend'
import { Element } from '../../../../../../../common/html/element'
import { Notification } from '../../../../../../../common/notification'
import { formatVal } from '../../../../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../../../../utils/common'
import {
  selectDistributionScore,
  selectDistributionScoreDes,
} from '../../../../store/slice'
import { COLOR_CHART_DISTRIBUTION } from './constants'

const DistributionOfScoreChart = ({ sortBy }) => {
  const distributionScore = useSelector(selectDistributionScore)
  const distributionScoreDes = useSelector(selectDistributionScoreDes)
  const locale = useSelector((state) => state.i18n.locale)

  // Text description
  const { industryName, companySizeName, modelSegmentName } =
    distributionScoreDes
  const des = {
    modelSegment: {
      title: 'distributionOfScore.modelSegment',
      value: modelSegmentName,
    },
    industry: {
      title: 'distributionOfScore.industryDes',
      value: industryName,
    },
    companySize: {
      title: 'distributionOfScore.companySize',
      value: companySizeName,
    },
  }

  const data = useMemo(() => {
    if (!Object.keys(distributionScore).length) return []
    return distributionScore[sortBy]
  }, [sortBy, distributionScore])

  if (!data || !data.length)
    return (
      <div style={{ height: 200 }}>
        <Notification />
      </div>
    )

  return (
    <div id="distributionOfScoreChartId" className="w100">
      <Element
        style={{
          color: '#9C9C9C',
          lineHeight: '16px',
          marginTop: 8,
        }}
      >
        <Translate value="distributionOfScore.numberOfCompanies" />
      </Element>
      <ChartContainer
        data={data}
        width="100%"
        height={280}
        margin={{
          left: 0,
          right: 8,
        }}
        xAxis={[{ dataKey: 'riskGradeTypeCode', height: 30 }]}
        yAxis={[
          {
            yAxisId: 'left',
            dataKeys: ['companyCount'],
            isBarChart: true,
            tickFormatter: (val) => formatVal(val, locale, false, 0),
          },
        ]}
        tooltip={{
          schema: {
            title: {
              hide: true,
            },
            content: [
              {
                label: 'distributionOfScore.riskGrade',
                isI18n: true,
                dataKey: 'riskGradeTypeCode',
              },
              {
                label: 'distributionOfScore.riskLevel',
                isI18n: true,
                dataKey: 'riskGradeTypeName',
              },
              {
                label: 'distributionOfScore.numberOfCompanies',
                isI18n: true,
                dataKey: 'companyCount',
              },
            ],
          },
        }}
      >
        <Bar yAxisId="left" dataKey="companyCount" barSize={36} fill="#facc5c">
          {data.map((entry) => (
            <Cell
              key={entry.riskGradeTypeCode}
              fill={
                entry.belongsTo
                  ? COLOR_CHART_DISTRIBUTION.ACTIVE
                  : COLOR_CHART_DISTRIBUTION.NOT_ACTIVE
              }
            />
          ))}
        </Bar>
      </ChartContainer>
      <div className="dFlex justifyContentBetween">
        <div>
          <Legend
            items={[
              {
                title: 'distributionOfScore.thisCompany',
                dataKey: 'riskGradeTypeCode',
                color: '#facc5c',
              },
            ]}
          />
          <Element className="dFlex mt1" style={{ lineHeight: '20px' }}>
            <Element style={{ fontWeight: 600 }}>
              {des[sortBy]?.title && <Translate value={des[sortBy].title} />}
            </Element>
            &nbsp;
            {des[sortBy]?.value || EMPTY_VALUE}
          </Element>
        </div>
      </div>
    </div>
  )
}

export default DistributionOfScoreChart
